"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDuplicates_de_de = void 0;
function backofficeDuplicates_de_de() {
    return {
        "backoffice.duplicates.confirmopentitle": "Öffnen bestätigen",
        "backoffice.duplicates.confirmopentext": "Alle aktuellen Änderungen werden verworfen. Wollen Sie fortfahren? Sie können das Duplikat auch in einem neuen Fenster öffnen!",
        "backoffice.duplicates.openduplicate": "öffnen",
        "backoffice.duplicates.fillinduplicate": "ausfüllen"
    };
}
exports.backofficeDuplicates_de_de = backofficeDuplicates_de_de;
